const heatResistantPopup = document.querySelector('#heatResistantPopup');
const heatResistantPopupButtons = document.querySelector('#heatResistantPopup .ohnuts-popup-buttons');
const heatResistantPopupMessageBox = document.querySelector('#heatResistantPopupMessageBox');
const addressBtnConatiner = document.querySelector('.address-btn-part');
const shipToMultiAddresseBtn = document.querySelector('#shipToMultiAddresseBtn');
const addressListSelect = document.querySelector('#address_list_slt');
const SHOP_METAFIELDS_CUSTOM_AUTO_APPLY_HEAT_RESISTANT= document.querySelector('#shop_metafields_custom_auto_apply_heat_resistant').value;


const MULTI_ADDRESS_ITEM_COUNT_THRESHOLD = 1;
let global_place_id="";
let address_list=[];

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  const cartItemCount = event?.cartData?.item_count || 0;
  if ((cartItemCount <= MULTI_ADDRESS_ITEM_COUNT_THRESHOLD)
    && addressBtnConatiner
    && shipToMultiAddresseBtn
  ) {
    const spaceNode = document.createTextNode('\u00A0');
    addressBtnConatiner.replaceChild(spaceNode, shipToMultiAddresseBtn);
  } else if ((cartItemCount > MULTI_ADDRESS_ITEM_COUNT_THRESHOLD)
    && addressBtnConatiner
    && !shipToMultiAddresseBtn
  ) {
    window.location.reload();
  }
});
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.href = ADDRESS_LIST_URL;
  }
});
$(document).ready(function() {
  $('#address_list_slt').select2();

  let isProgrammaticChange = false;
  $('#address_list_slt').on('change.select2', function (e) {
    if (isProgrammaticChange) return;

    isProgrammaticChange = true;

    const nativeEvent = new Event('change', { bubbles: true });
    this.dispatchEvent(nativeEvent);

    isProgrammaticChange = false;
  });
});

document.addEventListener('DOMContentLoaded', async function() {
  window.sessionStorage.removeItem(ADDRESS_REMOVAL_KEY);
  await fetchCustomerAddresses(checkPreviouslyChosenAddress);
  hideOhnutsLoadingSpinner();
});

async function fetchCustomerAddresses(callback = null) {
  const addressContainer = document.querySelector('#logged_customer_addresses');

  if (!addressContainer) {
    if (!callback) return;

    return callback();
  }

  const customer_id = addressContainer.getAttribute('data-customer-id');
  if (!customer_id) {
    if (!callback) return;
    return callback();
  }

  let hasNext = true;
  let cursor = null;
  const allAddresses = [];

  addressContainer.innerHTML = '';
  showOhnutsLoadingSpinner();
  try {
    while (hasNext) {
      const url = `${SHOPIFY_APP_BASE_URL}/customer-address-list`;
      const requestBody = {
        customer_id,
        ...(cursor && { cursor })
      };

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      };

      const response = await fetch(url, options);
      const responseJson = await response.json();

      const addresses = responseJson?.data?.addresses || [];
      hasNext = responseJson?.data?.page_info?.has_next_page || false;
      cursor = responseJson?.data?.page_info?.current_cursor || '';

      if (Array.isArray(addresses) && addresses.length) {
        allAddresses.push(...addresses);
        address_list.push(...addresses);
      } else {
        break;
      }
    }
  } catch (error) {
    console.error('Failed to fetch customer addresses. Error: ', error);
  }

  if (allAddresses.length) {
    addressContainer.innerHTML = JSON.stringify(allAddresses);
    prepareAndRenderAddressList(allAddresses);
  }

  if (callback) return callback();
}

function prepareAndRenderAddressList(addressList) {
  function isAddressInComplete(address) {
    const firstName = address?.first_name || null;
    const lastName = address?.last_name || null;
    const address1 = address?.address1 || null;
    const city = address?.city || null;
    const province = address?.province || null;
    const zip = address?.zip || null;
    const country = address?.country || null;
    return (!firstName
      || !lastName
      || !address1
      || !city
      || !province
      || !zip
      || !country
    );
  }

  function formatAddressDisplay(address) {
    return [
      (address.firstName && address.lastName
        ? `${address.firstName} ${address.lastName}`
        : address.firstName || address.lastName),
      address.name,
      address.address1,
      address.city,
      address.province_code && address.zip
        ? `${address.province_code} ${address.zip}`
        : address.zip || address.province_code,
      address?.phone ?? null,
    ].filter(Boolean).join(', ');
  }

  let addressListOptions = '';
  addressList.forEach((address) => {
    const addressId = address?.id || '';
    const inComplete = isAddressInComplete(address);
    const display = formatAddressDisplay(address);
    if (addressId) {
      addressListOptions += `<option value="${addressId}"
        ${inComplete ? 'class="incomplate-address-option"' : ''}
        data-value='${JSON.stringify(address)}'
      >
        ${display}${inComplete ? ' [INCOMPLETE ADDRESS]' : ''}
      </option>`;
    }
  });
  if (addressListOptions !== '') {
    addressListOptions = `<option value="">Select Address</option>${addressListOptions}`;
    addressListSelect.innerHTML = addressListOptions;
  }
}

function checkPreviouslyChosenAddress() {
  let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (Object.keys(cartMultiAddressList).length) {
    for (let addressId in cartMultiAddressList) {
      const targetAddress = document.querySelector(`#customer-address-${addressId}`);
      targetAddress && (targetAddress.checked = true);
    }
  }
}

const addAddressForShipping = document.querySelector('#addAddressForShipping');

if (addAddressForShipping) {
  addAddressForShipping.addEventListener('click', async (e) => {
    showOhnutsLoadingSpinner();
    // let processslow = false;
    await handleCartItemStockAvailable()
    .then(async (responsestock) => {
      if(responsestock.status==false){
        showOhnutsLrgCustomModal(
          responsestock.msg,
          'Product Out of Stock',
          'Confirm',
          '',
          shippingPageProccess,
          false
        )
      }else{
        shippingPageProccess();
      }
    });
  });
}
async function shippingPageProccess(){
  showOhnutsLoadingSpinner();
  const customer_id = document.querySelector('#customer_id')?.value || '';
  if (!customer_id) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Customer info missing, please reload page again',
      'Customer Error',
      'Close'
    );
  }
  await validateCustomerAddressForm()
  .then((response) => {
    const {invalidFields, address} = response;
    if (Array.isArray(invalidFields)
      && invalidFields.length
    ) {
      hideOhnutsLoadingSpinner();
      return showOhnutsCustomModal(
        'Mismatch detected between the address and ZIP code. Please correct them before proceeding',
        'Address Error',
        'Close'
      );
    } else if (Object.keys(address).length) {
      address['customer_id'] = customer_id;
      processAddressDataAndRedirect(customer_id, address);
    } else {
      return showOhnutsCustomModal(
        'Failed to validate, please try again',
        'Address Error',
        'Close'
      );
    }
  })
  .catch((error) => {
    console.log(error);
    return showOhnutsCustomModal(
      'Failed to validate, please try again',
      'Address Error',
      'Close'
    );
  });
}

function processAddressDataAndRedirect(customer_id, address) {
  // checking for address are already exits or not
  let addressformData = address;
  let matchingOption = null; // Initialize matchingOption

  let address_id = document.querySelector('#address_id')?.value || '';

  for (const option of addressListSelect.options) {
    if (option.value && option.dataset.value && !address_id) {
      try {
        const optionData = JSON.parse(option.dataset.value.replace(/&quot;/g, '"'));
        const isMatch = Object.keys(addressformData).every(key => {
          const addressValue = (addressformData[key] || "").toString().trim();
          const optionValue = (optionData[key] || "").toString().trim();
          const result = addressValue === optionValue;
          //console.log(`Key: ${key}, Address Value: "${addressValue}", Option Value: "${optionValue}", Match: ${result}`);
          return result;
        });

        if (isMatch) {
          matchingOption = option.value;
          address_id = matchingOption;
          const detailsElement = document.querySelector(`#customer-address-details`);
          if (detailsElement) {
            detailsElement.innerHTML = `
              ${JSON.stringify(optionData, null, 2)}
            `;
          }
          break;
        }
      } catch (e) {
        console.error("Error parsing data-value:", e);
      }
    }
  }
  if (!address_id) {
    const addressCreateError = 'Failed to create address';
    createCustomerAddress(customer_id, address)
    .then((responseJson) => {
      const chosenAddress = responseJson?.data || {};
      if (responseJson?.status === 'ok' && chosenAddress) {
        if (isAddressIncomplete(chosenAddress)) {
          const addressDisplay = addressDisplayForList(chosenAddress);
          let addressErrorMsg = `Address : <strong>${addressDisplay}</strong> is incomplete,`;
          addressErrorMsg += ` Please choose another one or update this one before using it`;
          hideOhnutsLoadingSpinner();
          return showOhnutsCustomModal(
            addressErrorMsg,
            'Address Error'
          );
        }

        fetchCartDataAndSetShippingInfo(chosenAddress);
      } else {
        hideOhnutsLoadingSpinner();
        return showOhnutsCustomModal(
          responseJson?.message || addressCreateError,
          'Address Create Error',
          'Close'
        );
      }
    })
    .catch((e) => {
      console.error(e);
      hideOhnutsLoadingSpinner();
      return showOhnutsCustomModal(
        addressCreateError,
        'Address Create Error',
        'Close'
      );
    });
  } else {
    const addressDetailsEle = document.querySelector(`#customer-address-details`);
    if (!addressDetailsEle?.innerHTML) {
      hideOhnutsLoadingSpinner();
      return showOhnutsCustomModal(
        'Address element missing, please choose another one',
        'Address Error',
        'Close'
      );
    }
    let chosenAddress = {}
    try {
      chosenAddress = JSON.parse(addressDetailsEle?.innerHTML);
    } catch (error) {
      selectedAddress.checked = false;
      console.error(`Failed during parsing address : `, error);
      hideOhnutsLoadingSpinner();
      return showOhnutsCustomModal(
        'Address parsing error, please choose another one',
        'Address Error',
        'Close'
      );
    }
    if (isAddressIncomplete(chosenAddress)) {
      selectedAddress.checked = false;
      const addressDisplay = addressDisplayForList(chosenAddress);
      let addressErrorMsg = `Address : <strong>${addressDisplay}</strong> is incomplete,`;
      addressErrorMsg += ' Please choose another one or update this one before using it';
      hideOhnutsLoadingSpinner();
      return showOhnutsCustomModal(
        addressErrorMsg,
        'Address Error'
      );
    }
    const checkingFields = [
      'firstName',
      'lastName',
      'company',
      'address1',
      'address2',
      'city',
      'province',
      'country',
      'zip',
      'phone',
      'default'
    ];
    if (areAddressesEqual(address, chosenAddress, checkingFields)) {
      fetchCartDataAndSetShippingInfo(chosenAddress);
    } else {
      const addressUpdateError = 'Failed to update address';
      updateCustomerAddress(customer_id, address_id, address)
      .then((responseJson) => {
        //console.log(responseJson);
        const chosenAddress = responseJson?.data || {};
        if (responseJson?.status === 'ok' && chosenAddress) {
          if (isAddressIncomplete(chosenAddress)) {
            const addressDisplay = addressDisplayForList(chosenAddress);
            let addressErrorMsg = `Address : <strong>${addressDisplay}</strong> is incomplete,`;
            addressErrorMsg += ` Please choose another one or update this one before using it`;
            hideOhnutsLoadingSpinner();
            return showOhnutsCustomModal(
              addressErrorMsg,
              'Address Error'
            );
          }

          fetchCartDataAndSetShippingInfo(chosenAddress);
        } else {
          hideOhnutsLoadingSpinner();
          return showOhnutsCustomModal(
            responseJson?.message || addressUpdateError,
            'Address Update Error',
            'Close'
          );
        }
      })
      .catch((e) => {
        console.error(e);
        hideOhnutsLoadingSpinner();
        return showOhnutsCustomModal(
          addressUpdateError,
          'Address Update Error',
          'Close'
        );
      });
    }
  }
}

async function validateCustomerAddressForm() {
  const address = {};
  const invalidFields = [];

  function getFieldValue(selector, key, displayName, required = true) {
    const value = document.querySelector(selector).value.trim();
    if (value || !required) {
      address[key] = value;
    } else {
      invalidFields.push({
        selector,
        displayName
      });
    }
    return value;
  }

  function getCountryAndProvince() {
    const country_ele = document.querySelector('#AddressCountryNew');
    const province_ele = document.querySelector('#AddressProvinceNew');

    const selected_country_index = country_ele.selectedIndex;
    const country_list = country_ele.options;
    const country_name = country_list[selected_country_index]?.value.trim() || '';
    if (country_name !== "---" || country_name !== '') {
      address['country'] = address['country_name'] = country_name;
    } else {
      invalidFields.push({
        selector: '#AddressCountryNew',
        displayName: 'Country'
      });
    }

    let country_provinces;
    try {
      country_provinces = JSON.parse(
        country_list[selected_country_index]?.getAttribute("data-provinces") || "[]"
      );
    } catch {
      console.error(`[getCountryAndProvince] Invalid provinces JSON: ${error.message}`);
      country_provinces = [];
    }

    const selected_province_index = province_ele.selectedIndex;
    const province_list = province_ele.options;
    const province_name = province_list[selected_province_index]?.value || "";

    if (country_provinces.length) {
      if (selected_province_index >= 0 && province_name !== "") {
        address['province'] = province_name;
      } else {
        invalidFields.push({
          selector: '#AddressProvinceNew',
          displayName: 'State'
        });
      }
    } else {
      address['province'] = '';
    }
  }

  getFieldValue('#AddressFirstNameNew', 'firstName', 'First name');
  getFieldValue('#AddressLastNameNew', 'lastName', 'Last name');
  getFieldValue('#AddressCompanyNew', 'company', 'Company', false);
  getFieldValue('#AddressAddress1New', 'address1', 'Address');
  getFieldValue('#AddressAddress2New', 'address2', 'Apartment, suite, etc', false);
  getFieldValue('#AddressCityNew', 'city', 'City');
  getFieldValue('#AddressZipNew', 'zip', 'Zip Code');
  getFieldValue('#AddressPhoneNew', 'phone', 'Phone', false);

  address['default'] = !!document.querySelector(
    '#address_default_address_new:checked'
  );

  getCountryAndProvince();
  if (Object.hasOwn(address, 'firstName')
    && Object.hasOwn(address, 'lastName')
  ) {
    address['name'] = `${address['firstName']} ${address['lastName']}`;
  }
  const address_id = document.querySelector('#address_id')?.value || '';
  if (address_id) address['id'] = address_id;
  const googleapiValidtedaddress = await isGoogleapiValidEndPointcal(address);
  if(googleapiValidtedaddress==false) {
    invalidFields.push({
      selector: '#AddressZipNew',
      displayName: 'Mismatch detected between the address and ZIP code. \n We couldnot validate the address.\n Please correct them before proceeding'
    });
  }else {
    Object.assign(address, googleapiValidtedaddress);
  }
  //console.log("googleapiValidtedaddress=>",googleapiValidtedaddress);
  if (!address_id){
    const isAddressAlreadyExist = await isAddressExistsInAddresslist(address);
    address['id'] = isAddressAlreadyExist;
  }
  return { invalidFields, address };
}

// async function isGoogleapiValidEndPointcal(address) {
//   const addressLine = `${address.address1}, ${address.city}, ${address.province}, ${address.country}`;
//   const request = {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({ addressLine }),
//   };

//   try {
//     //const response = await fetch(`https://shopifymultishipapp-ec3e3bef6fd5.herokuapp.com/get-postal-address-suggestions-gapi`, request);
//     const response = await fetch(`${SHOPIFY_APP_BASE_URL}/get-postal-address-suggestions-gapi`,request);
//     const result = await response.json();

//     if (result?.status?.toLowerCase() === "ok" && result?.data) {
//       const apiData = result.data;
//       //console.log("Google API Response:", apiData);
//       //console.log("User Address:", address);
//       let isMatch;
//       if (apiData.city === null || apiData.city === ""){
//         isMatch =
//           normalizeAddress(address.zip).startsWith(normalizeAddress(apiData.zip)) &&
//           normalizeAddress(address.province) === normalizeAddress(apiData.province) &&
//           normalizeAddress(address.country) === normalizeAddress(apiData.country) &&
//           normalizeAddress(address.address1) === normalizeAddress(apiData.address1);
//       // } else if (apiData.address1 === null || apiData.address1 === ""){
//       //   isMatch =
//       //     normalizeAddress(address.zip).startsWith(normalizeAddress(apiData.zip)) &&
//       //     normalizeAddress(address.city) === normalizeAddress(apiData.city) &&
//       //     normalizeAddress(address.province) === normalizeAddress(apiData.province) &&
//       //     normalizeAddress(address.country) === normalizeAddress(apiData.country);
//       }else{
//         isMatch =
//           normalizeAddress(address.zip).startsWith(normalizeAddress(apiData.zip)) &&
//           normalizeAddress(address.city) === normalizeAddress(apiData.city) &&
//           normalizeAddress(address.province) === normalizeAddress(apiData.province) &&
//           normalizeAddress(address.country) === normalizeAddress(apiData.country) &&
//           normalizeAddress(address.address1) === normalizeAddress(apiData.address1);
//       }
//       if (!isMatch) {
//         // console.warn("Address mismatch:", {
//         //   zip: [address.zip, apiData.zip],
//         //   city: [address.city, apiData.city],
//         //   province: [address.province, apiData.province],
//         //   country: [address.country, apiData.country],
//         //   address1: [address.address1, apiData.address1]
//         // });
//         hideOhnutsLoadingSpinner();
//         return await new Promise((resolve) => {
//           const userAddressText = formatAddress(address);
//           const suggestedAddressText = formatAddress(apiData);
//           document.getElementById("userAddressText").innerText = userAddressText;
//           document.getElementById("suggestedAddressText").innerText = suggestedAddressText;
//           const modal = document.getElementById("addressSuggestionModal");
//           modal.style.display = 'block';
//           document.getElementById("chooseUserAddress").onclick = () => {
//             modal.style.display = 'none';
//             //resolve(true);  // Proceed with user-entered address
//             resolve(false);
//           };
//           document.getElementById("chooseSuggestedAddress").onclick = () => {
//             modal.style.display = 'none';
//             //Object.assign(address, apiData);
//             const combinedAddress = {
//               ...address, 
//               address1: apiData.address1 || address.address1,
//               city: apiData.city || address.city,
//               province: apiData.province || address.province,
//               country: apiData.country || address.country,
//               zip: apiData.zip || address.zip
//           };
//           resolve(combinedAddress);
//           };
//         });
//       }else{
//         return address;
//       }

//       //return false;//Mismatch detected between the address and ZIP code. Please correct them before proceeding
//       //return isMatch;
//     } else {
//       console.warn("Invalid GAPI response:", result.message || result);
//       return false;
//     }
//   } catch (error) {
//     console.error("Error validating address with Google API:", error);
//     return false;
//   }
// }
async function isGoogleapiValidEndPointcal(address) {
  if(global_place_id){
    const place_details =  await calToPlaceDetailsbyPlaceid(global_place_id);
        if(place_details){
          populateFields(place_details);
          return address;
        }else{
          global_place_id='';
          await isGoogleapiValidEndPointcal(address);
        }
  }else{
    try {
      const url = `${SHOPIFY_APP_BASE_URL}/get-postal-address-suggestions-gapi-v1`;
      //const url = `https://shopifymultishipapp-ec3e3bef6fd5.herokuapp.com/get-postal-address-suggestions-gapi`;
      //const url = `http://127.0.0.1:5000/get-postal-address-suggestions-gapi`;
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(address)
      };
      const response = await fetch(url, options);
      const responseJson = await response.json();
      const data = responseJson?.data ?? {};
      if (isEmptyObject(data)) {
        console.warn("Invalid GAPI response: ", responseJson);
        return false;
      }
      const valid = data?.valid ?? false;
      const suggestedAddress = data?.suggested_address ?? {};
      const mismatchedFields = data?.mismatched_fields ?? [];

      if (valid) return address;
      if (isEmptyObject(suggestedAddress) && mismatchedFields.length > 0) {
        console.warn("Address not valid, and mismatched fields present:", mismatchedFields);
        return false;
      }

      if (isEmptyObject(suggestedAddress) && !valid) {
        console.warn("Address not valid and no suggestion provided.",mismatchedFields);
        return false;
      }
      hideOhnutsLoadingSpinner();
      return await new Promise((resolve) => {
        const userAddressText = formatAddress(address);
        const suggestedAddressText = formatAddress(suggestedAddress);
        document.getElementById("userAddressText").innerText = userAddressText;
        document.getElementById("suggestedAddressText").innerText = suggestedAddressText;
        const modal = document.getElementById("addressSuggestionModal");
        modal.style.display = "block";
        document.getElementById("chooseUserAddress").onclick = () => {
          modal.style.display = "none";
          //resolve(false); // not Proceed with user-entered address
          resolve(address);  // Proceed with user-entered address
        };
        document.getElementById("chooseSuggestedAddress").onclick = async () => {
          modal.style.display = "none";
          const updatedAddress1 = suggestedAddress?.address1 ?? address.address1;

          const updatedCity = suggestedAddress?.city ?? address.city;
          const updatedProvince = suggestedAddress?.province ?? address.province;
          const updatedCountry = suggestedAddress?.country ?? address.country;
          const updatedZip = suggestedAddress?.zip ?? address.zip;
          let combinedAddress = {
            ...address,
            address1: updatedAddress1,
            city: updatedCity,
            province: updatedProvince,
            country: updatedCountry,
            zip: updatedZip,
          };
          resolve(combinedAddress);
        };
      });
    } catch (error) {
      console.error("Failed to validate address with Google API. Error: ", error);
      return false;
    }
  }
}

function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function isEmptyObject(obj) {
  return !isObject(obj) || Object.keys(obj).length === 0;
}

function formatAddress(addr) {
  return `${addr.address1 || ''}, ${addr.city || ''}, ${addr.province || ''}, ${addr.zip || ''}, ${addr.country || ''}`;
}
async function putsuggestedaddress(addr){
  await populateFields(addr);
  return true;
}
function normalizeAddress(str) {
  const suffixMap = {
    'st': 'street',
    'rd': 'road',
    'ave': 'avenue',
    'blvd': 'boulevard',
    'dr': 'drive',
    'ln': 'lane',
    'pkwy': 'parkway',
    'cir': 'circle',
    'ct': 'court',
    'hwy': 'highway',
    'trl': 'trail',
    'ter': 'terrace',
    'pl': 'place',
    'sq': 'square',
    'way': 'way',
  };

  const directionMap = {
    'n': 'north',
    's': 'south',
    'e': 'east',
    'w': 'west',
  };

  // Helper: Replace based on map
  const replaceWithMap = (input, map) => {
    const pattern = new RegExp(`\\b(${Object.keys(map).join('|')})\\b`, 'g');
    return input.replace(pattern, (match) => map[match]);
  };

  // Helper: Convert street numbers to ordinals
  const ordinalize = (input) => {
    return input.replace(/\b(\d{1,2})(?=\s+(street|st|avenue|ave|road|rd|boulevard|blvd|drive|dr))\b/gi, (match, num) => {
      const n = parseInt(num);
      const v = n % 100;
      const suffix = (v > 10 && v < 14) ? 'th' : ['th', 'st', 'nd', 'rd'][(n % 10)] || 'th';
      return `${n}${suffix}`;
    });
  };

  // Process the string
  str = str.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
  str = replaceWithMap(str, suffixMap);
  str = replaceWithMap(str, directionMap);
  str = ordinalize(str);
  return str.trim();
}

function showError(input, message) {
  const error = document.createElement("div");
  error.className = "error-message";
  error.style.color = "red";
  error.textContent = message;
  input.parentNode.appendChild(error);
}
async function createCustomerAddress(customer_id, address) {
  const url = `${SHOPIFY_APP_BASE_URL}/create-customer-address`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      //customer_access_token,
      customer_id,
      address,
    }),
  };
  return await fetchService(url, options);
}

async function updateCustomerAddress(customer_id, address_id, address) {
  const url = `${SHOPIFY_APP_BASE_URL}/update-customer-address`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      //customer_access_token,
      customer_id,
      address_id,
      address,
    }),
  };
  return await fetchService(url, options);
}

function areAddressesEqual(address1, address2, checkingFields=[]) {
  if (!checkingFields.length) return areObjectsEqual(address1, address2);

  for (const checkingField of checkingFields) {
    if (!Object.hasOwn(address1, checkingField)) return false;
    if (!Object.hasOwn(address2, checkingField)) return false;
    if (address1[checkingField] !== address2[checkingField]) return false;
  }

  return true;
}

async function fetchCartDataAndSetShippingInfo(chosenAddress) {
  const url = window.Shopify.routes.root + 'cart.js';
  const options = {};
  fetchService(url, options)
  .then((responseJson) => {
    setInfoForShipping(chosenAddress, responseJson);
  })
  .catch((e) => {
    console.error(e);
    hideOhnutsLoadingSpinner();
    showOhnutsCustomModal(
      'Failed to retrieve cart data',
      'Cart Error',
      'Close',
      CART_REDIRECT_URL
    );
  });
}

async function fetchService(url, options) {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("FetchService error:", error);
    throw error; 
  } finally {
    hideOhnutsLoadingSpinner();
  }
}

function addressDisplayForList(address) {
  const addressDisplay = [];
  const displayFields = [
    'address1',
    'city',
    'province_code',
    'zip',
    'phone'
  ];
  if (Object.keys(address).length) {
    for (const displayField of displayFields) {
      if (Object.hasOwn(address, displayField) && address[displayField]) {
        addressDisplay.push(address[displayField]);
      }
    }
  }
  return addressDisplay.join(", ");
}

function setInfoForShipping(chosenAddress, cartJson) {
  if (!Object.keys(chosenAddress).length) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Address info not found!',
      'Address Error',
      'Close'
    );
  }
  const cartToken = cartJson?.token ?? null;
  let cartItems = cartJson?.items ?? null;
  if (!cartToken || !cartItems) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      "Failed to retrieve cart data",
      "Cart Error",
      "Close",
      CART_REDIRECT_URL
    );
  }
 
  cartItems = getSlimCartItems(cartItems);
  saveOhnutsInfo(SINGLE_CART_TOKEN_KEY, cartToken);
  saveOhnutsInfo(SINGLE_CART_ITEMS_KEY, JSON.stringify(cartItems));
  let oldGiftMessage = "";
  let oldShippingRate = "";
  let oldDeliveryDate = "";
  const oldCartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (Object.keys(oldCartMultiAddressList).length == 1) {
    for (const key in oldCartMultiAddressList) {
      oldGiftMessage = oldCartMultiAddressList[key]?.giftMessage || oldGiftMessage;
      oldShippingRate = oldCartMultiAddressList[key]?.shippingRate || oldShippingRate;
      oldDeliveryDate = oldCartMultiAddressList[key]?.deliveryDate || oldDeliveryDate;
    }
  }
  //console.log(oldCartMultiAddressList);
  let cartMultiAddressList = {};
  cartMultiAddressList[chosenAddress.id] = {
    "blockId": chosenAddress.id,
    "address": chosenAddress,
    "cartItems": cartItems,
    "giftMessage": oldGiftMessage,
    "shippingRate": oldShippingRate,
    "deliveryDate": oldDeliveryDate
  };
  saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
  //console.log(JSON.stringify(cartMultiAddressList));
  if (SHOP_METAFIELDS_CUSTOM_AUTO_APPLY_HEAT_RESISTANT == 'true') {
    addHeatResistantVariantsToCart(SINGLE_ADDRESS_SHIPPING_URL);
  } else {
    hideOhnutsLoadingSpinner();           
    window.location.href = SINGLE_ADDRESS_SHIPPING_URL;
  }
}

const addressRemoveBtns = document.querySelectorAll('.remove-address');
if (addressRemoveBtns) {
  addressRemoveBtns.forEach((addressRemoveBtn) => {
    addressRemoveBtn.addEventListener('click', (e) => {
      const target = e.target.closest('button');
      triggerAddressRemoval(target);
    })
  });
}

function triggerAddressRemoval(target) {
  const addressId = target.getAttribute('data-address-id');
  const targetAddresscard = target.closest('.address-card');
  if (!addressId || !targetAddresscard) {
    return showOhnutsCustomModal(
      'Address info not found!',
      'Address Error',
      'Close'
    );
  }
  let addressDisplay = targetAddresscard.querySelector('.radio-txt');
  addressDisplay = addressDisplay?.innerHTML || "";
  if (addressDisplay != "") {
    addressDisplay = addressDisplay.replace(/<p>/g, '<h4>').replace(/<\/p>/g, '</h4>');
  }
  let addressInfo = targetAddresscard.querySelector(`#customer-address-${addressId}-details`);
  addressInfo = addressInfo?.innerHTML || "{}";
  try {
    addressInfo = JSON.parse(addressInfo);
  } catch (error) {
    console.error('Failed during parsing address : ', error);
    return showOhnutsCustomModal(
      'Address info not found!',
      'Address Error',
      'Close'
    );
  }
  const customerId = addressInfo?.customer_id || "";
  if (customerId == "") {
    return showOhnutsCustomModal(
      'Customer info not found!',
      'Customer Error',
      'Close'
    );
  }
  window.sessionStorage.setItem(
    ADDRESS_REMOVAL_KEY,
    JSON.stringify({
      "customer_id": customerId,
      "address_id": addressId
    })
  );
  return showOhnutsCustomModal(
    addressDisplay,
    'Remove Address',
    'Confirm',
    "",
    removeSelectedAddress,
    true
  );
}

function removeSelectedAddress() {
  let addressRemovalInfo = window.sessionStorage.getItem(ADDRESS_REMOVAL_KEY);
  if (!addressRemovalInfo) {
    return showOhnutsCustomModal(
      'Removal info not found!',
      'Remove Address Error',
      'Close'
    );
  }

  try {
    addressRemovalInfo = JSON.parse(addressRemovalInfo);
  } catch (error) {
    console.error(`Failed during parsing address : `, error);
    return showOhnutsCustomModal(
      'Address removal parsing error',
      'Remove Address Error',
      'Close'
    );
  }

  const customer_id = addressRemovalInfo?.customer_id ?? null;
  const address_id = addressRemovalInfo?.address_id ?? null;
  if (!customer_id || !address_id) {
    return showOhnutsCustomModal(
      'Removal info not found!',
      'Remove Address Error',
      'Close'
    );
  }

  const url = `${SHOPIFY_APP_BASE_URL}/delete-customer-address`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      customer_id,
      address_id
    })
  };

  showOhnutsLoadingSpinner();
  fetch(url, options)
  .then(response => response.json())
  .then(response => {
    if (response?.status && (response.status == "ok")) {
      afterRemovalUpdateAddressUI(address_id);
    } else {
      let errorMessage = "Failed to remove address, please try again";
      errorMessage = response?.message?.length
        ? response.message
        : errorMessage;

      return showOhnutsCustomModal(
        errorMessage,
        'Remove Address Error',
        'Close'
      );
    }
  })
  .catch(error => {
    console.error(error);
    return showOhnutsCustomModal(
      'Failed to remove address, please try again',
      'Remove Address Error',
      'Close'
    );
  })
  .finally(() => {
    hideOhnutsLoadingSpinner();
  });
}

function afterRemovalUpdateAddressUI(removed_address_id) {
  const addressInput = document.querySelector(`#customer-address-${removed_address_id}`);
  if (addressInput) {
    const targetAddresscard = addressInput.closest('.address-card');
    targetAddresscard && targetAddresscard.remove();
    const allAddressCards = document.querySelectorAll('.address-card');
    if (!allAddressCards.length) {
      const origin = window.location.origin;
      const pathname = window.location.pathname;
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const page = urlParams.get('page');
      let targetPage = `${origin}${pathname}`;
      if (page && !isNaN(parseInt(page)) && (parseInt(page) > 1)) {
        targetPage = `${origin}${pathname}?page=${parseInt(page) - 1}`;
      }
      showOhnutsLoadingSpinner();
      window.location.href = targetPage;
    }
  }
}

if (shipToMultiAddresseBtn) {
  shipToMultiAddresseBtn.addEventListener('click', (e) => {
    showOhnutsLoadingSpinner();
    const showLoginWarning = shipToMultiAddresseBtn.getAttribute('data-show-login-warning');
    const redirectURL = shipToMultiAddresseBtn.getAttribute('data-url');
    if (showLoginWarning && redirectURL) {
      if (showLoginWarning == "1") {
        return showOhnutsCustomModal(
          'You must log in first for shipping to multiple addresses',
          'Multi-address Shipping',
          'Login',
          redirectURL,
          null,
          true
        );
      } else {
        hideOhnutsLoadingSpinner();
        window.location.href = redirectURL;
      }
    }
  });
}

const addressEditBtns = document.querySelectorAll('.edit-address');
if (addressEditBtns) {
  addressEditBtns.forEach((addressEditBtn) => {
    addressEditBtn.addEventListener('click', (e) => {
      showOhnutsLoadingSpinner();
      const target = e.target.closest('button');
      const addressId = target.getAttribute('data-address-id');
      if (addressId) {
        const search = window.location.search;
        const redirectURL = `${ADDRESS_LIST_URL}${search}`;
        const targetURL = `${SINGLE_ADDRESS_UPDATE_URL}/${addressId}?redirect_url=${redirectURL}`;
        hideOhnutsLoadingSpinner();
        window.location.href = targetURL;
      } else {
        hideOhnutsLoadingSpinner();
        return showOhnutsCustomModal(
          'Address info not found!',
          'Address Error',
          'Close'
        );
      }
    });
  });
}

function addHeatResistantVariantsToCart(redirectURL=null) {
  const heatResistantVariantId = getHeatResistantVariantId();
  const variantsRequiredHeatResistant = getCartVariantsRequiredHeatResistant();
  if (!heatResistantVariantId || !variantsRequiredHeatResistant) {
    if (redirectURL) {
      hideOhnutsLoadingSpinner();
      window.location.href = redirectURL;
      return;
    }
  }
  const targetAddressBlocks = [];
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  for (const [blockId, blockDetails] of Object.entries(cartMultiAddressList)) {
    const cartItems = blockDetails?.cartItems || [];
    if (cartItems.length) {
      variantsRequiredHeatResistant.forEach((variantRequiredHeatResistant) => {
        const heatResistantRequired = cartItems.some(
          cartItem => (
            String(cartItem.variant_id) === String(variantRequiredHeatResistant)
          )
        );
        const heatResistantExists = cartItems.filter(
          cartItem => (
            String(cartItem.variant_id) === String(heatResistantVariantId)
          )
        );
        if (heatResistantRequired &&
          !heatResistantExists.length &&
          (targetAddressBlocks.indexOf(blockId) === -1)
        ) {
          targetAddressBlocks.push(blockId);
        }
      })
    }
  }
  
  if (!targetAddressBlocks.length) {
    if (redirectURL) {
      hideOhnutsLoadingSpinner();
      window.location.href = redirectURL;
      return;
    }
  }

  const items = [
    {
      "id": heatResistantVariantId,
      "quantity": targetAddressBlocks.length
    }
  ];

  const url = window.Shopify.routes.root + `cart/add.js`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'items': items
    })
  };
  hideOhnutsLoadingSpinner();
  hideHeatResistantPopupMessage();
  setHeatResistantPopupLoading();
  showHeatResistantPopup();
  fetch(url, options)
  .then((response) => response.json())
  .then((responseJson) => {
    if (areRequestItemsEqualsResponseItems(items, responseJson)) {
      let preparedResponseJson = responseJson.items.filter(
        item => item?.quantity
      ).map((item) => {
        item.quantity = 1
        return item;
      });
      preparedResponseJson = getSlimCartItems(preparedResponseJson);
      addHeatResistantVariantsToAddressBlocks(
        targetAddressBlocks,
        preparedResponseJson
      );
      fetchCartDataAndUpdateAddressBlockProducts(redirectURL);
    } else {
      let errorMessage = 'Failed to add heat resistant packaging(s), please reload the page';

      if (responseJson?.status !== 200 && responseJson?.description?.length) {
        errorMessage = responseJson.description;
      }

      showHeatResistantPopupMessage(
        errorMessage,
        'error'
      );
    }
  })
  .catch((e) => {
    console.error(e);
    showHeatResistantPopupMessage(
      'Failed to add heat resistant packaging(s), please reload the page',
      'error'
    );
  })
  .finally(() => {
    resetHeatResistantPopupLoading();
  });
}

function getHeatResistantVariantId() {
  let variantId = null;
  const content = document.querySelector('#variants_required_heat_resistant');
  if (content) {
    variantId = content.getAttribute('data-heat-resistant-variant-id');
  }
  return variantId;
}

function getCartVariantsRequiredHeatResistant() {
  let variantsRequiredHeatResistant = [];
  const content = document.querySelector('#variants_required_heat_resistant')?.innerHTML;
  if (content) {
    try {
      variantsRequiredHeatResistant = JSON.parse(content);
    } catch (error) {
      console.error(
        `[getCartVariantsRequiredHeatResistant] Error parsing in JSON : ${error.message}`
      );
      variantsRequiredHeatResistant = [];
    }
  }
  return variantsRequiredHeatResistant;
}

function showHeatResistantPopup() {
  if (heatResistantPopup) {
    heatResistantPopup.style.visibility = "visible";
    heatResistantPopup.style.zIndex = "9999";
  }
}

function hideHeatResistantPopup() {
  if (heatResistantPopup) {
    heatResistantPopup.style.visibility = "hidden";
    heatResistantPopup.style.zIndex = "0";
  }
}

function setHeatResistantPopupLoading() {
  if (heatResistantPopupButtons &&
    !heatResistantPopupButtons.classList.contains('loading')
  ) {
    heatResistantPopupButtons.classList.add('loading')
  }
}

function resetHeatResistantPopupLoading() {
  if (heatResistantPopupButtons?.classList?.contains('loading')) {
    heatResistantPopupButtons.classList.remove('loading')
  }
}

function showHeatResistantPopupMessage(message='', type='success') {
  if (heatResistantPopupMessageBox) {
    heatResistantPopupMessageBox.innerHTML = message;
  }

  if (heatResistantPopupMessageBox.classList.contains('hidden')) {
    heatResistantPopupMessageBox.classList.remove('hidden')
  }

  switch (type) {
    case "success":
      if (!heatResistantPopupMessageBox.classList.contains('success')) {
        heatResistantPopupMessageBox.classList.add('success')
      }
      break;

    case "error":
      if (!heatResistantPopupMessageBox.classList.contains('error')) {
        heatResistantPopupMessageBox.classList.add('error')
      }
      break;
  }
}

function hideHeatResistantPopupMessage() {
  if (heatResistantPopupMessageBox) {
    heatResistantPopupMessageBox.innerHTML = "";
  }

  if (!heatResistantPopupMessageBox.classList.contains('hidden')) {
    heatResistantPopupMessageBox.classList.add('hidden')
  }

  if (heatResistantPopupMessageBox.classList.contains('success')) {
    heatResistantPopupMessageBox.classList.remove('success')
  }

  if (heatResistantPopupMessageBox.classList.contains('error')) {
    heatResistantPopupMessageBox.classList.remove('error')
  }
}

function addHeatResistantVariantsToAddressBlocks(blockIds, heatResistantVariants) {
  let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  for (const blockId of blockIds) {
    if (cartMultiAddressList[blockId]) {
      cartMultiAddressList[blockId]["cartItems"] = cartMultiAddressList[blockId]["cartItems"].concat(
        heatResistantVariants
      );
    }
  }
  saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
}

function fetchCartDataAndUpdateAddressBlockProducts(redirectURL=null) {
  fetch(window.Shopify.routes.root + 'cart.js')
	.then((response) => response.json())
	.then((responseJson) => {
		const cartToken = responseJson?.token || null;
    let cartItems = responseJson?.items || null;
		if (!cartToken || !cartItems) {
      hideHeatResistantPopup();
			return showOhnutsCustomModal(
				"Failed to retrieve cart data",
				"Cart Error",
				"Close",
				CART_REDIRECT_URL
			);
		}
    cartItems = getSlimCartItems(cartItems);
		saveOhnutsInfo(SINGLE_CART_TOKEN_KEY, cartToken);
		saveOhnutsInfo(SINGLE_CART_ITEMS_KEY, JSON.stringify(cartItems));
    showHeatResistantPopupMessage(
      'Heat resistant packaging(s) added to cart',
      'success'
    );
    setTimeout(() => {
      hideHeatResistantPopup();
      if (redirectURL) {
        addClassesToElements(
          '#addAddressForShipping',
          ['read-only']
        );
        window.location.href = redirectURL;
      }
    }, 3000)
	})
	.catch((e) => {
    hideHeatResistantPopup();
		console.error(e);
		return showOhnutsCustomModal(
			"Failed to retrieve cart data",
			"Cart Error",
			"Close",
			CART_REDIRECT_URL
		);
	});
}

//////////////////////////////////////////////
  //const SHOPIFY_APP_BASE_URL_CALL='https://multi-address-order-30436288b667.herokuapp.com/api';
  const input = document.getElementById('AddressAddress1New');
  const suggestionsContainer = document.getElementById('addressSuggestions');
  const address1Field= document.getElementById('AddressAddress1New');
  const address2Field= document.getElementById('AddressAddress2New');
  const cityField = document.getElementById('AddressCityNew');
  const countryField = document.getElementById('AddressCountryNew');
  const pinField = document.getElementById('AddressZipNew');
  const stateField = document.getElementById('AddressProvinceNew');
  let debounceTimeout;
  /*
  if(input){
    input.addEventListener('input', () => {
      clearTimeout(debounceTimeout); // Clear the previous timeout
      debounceTimeout = setTimeout(async () => {
          const value = input.value.trim(); // Get the trimmed value
          if (value.length > 2 && value.length < 40) {
              try {
                  const suggestions = await callAddressSuggestion(value);
                  displaySuggestions(suggestions, value);
              } catch (error) {
                  console.error('Error fetching suggestions:', error);
              }
          }else{
            suggestionsContainer.innerHTML = ''; // Clear suggestions if input is too short
          }
      },300); // Adjust the debounce delay as needed (300ms here)
    });
  }
  async function callAddressSuggestion(addressLine) {
      const requestOptions = {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ addressLine }),
      };

      try {
          const response = await fetch(`https://shopifymultishipapp-ec3e3bef6fd5.herokuapp.com/address_suggestions-gapi`, requestOptions);
          //const response = await fetch(`${SHOPIFY_APP_BASE_URL}/address-suggestions-gapi`, requestOptions);
          const result = await response.json();

          if (result?.status?.toLowerCase() === "ok") {
              console.log(result);
              return result.data || [];
          } else {
              console.warn("Failed to fetch address suggestions:", result.message || "Unknown error");
              return '';
          }
      } catch (error) {
          console.error("Error fetching address suggestions:", error);
          return '';
      }
  }
  // Display suggestions in the dropdown
  function displaySuggestions(suggestions,inputvalue) {
    suggestionsContainer.innerHTML = ''; // Clear previous suggestions
    suggestions.forEach((suggestion) => {
        const div = document.createElement('div'); // Create a div for each suggestion
        div.textContent = suggestion; // Use the plain string directly
        div.style.padding = '10px'; // Add some styling
        div.style.cursor = 'pointer'; // Make it clickable

        // Add click event to update input field
        div.addEventListener('click', () => {
            input.value = inputvalue; // Set input value to the selected suggestion
            suggestionsContainer.innerHTML = ''; // Clear suggestions
            populateFields(suggestion);
        });
        suggestionsContainer.appendChild(div); // Append the div to the suggestions container
    });
    
  }
  */
  if (input) {
    input.addEventListener('input', () => {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(async () => {
        const value = input.value.trim();
        if (value.length > 0 && value.length < 220) {
          try {
            const suggestions = await callAddressSuggestion(value);
            displaySuggestions(suggestions);
          } catch (error) {
            console.error('Error fetching suggestions:', error);
          }
        } else {
          suggestionsContainer.innerHTML = ''; // Clear suggestions
        }
      }, 300);
    });
  }
  async function callAddressSuggestion(addressLine) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ addressLine }),
    };
    try {
      //const response = await fetch(`https://shopifymultishipapp-ec3e3bef6fd5.herokuapp.com/address_suggestions-gapi`, requestOptions);
      const response = await fetch(`${SHOPIFY_APP_BASE_URL}/address-suggestions-gapi`, requestOptions);
      const result = await response.json();
      if (result?.status?.toLowerCase() === "ok") {
        return result.data || {};
      } else {
        console.warn("Failed to fetch address suggestions:", result.message || "Unknown error");
        return {};
      }
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      return {};
    }
  }
  async function displaySuggestions(suggestionsObject) {
    suggestionsContainer.innerHTML = ''; 
    Object.entries(suggestionsObject).forEach(([placeId, text]) => {
      const div = document.createElement('div');
      div.textContent = text;
      div.style.padding = '10px';
      div.style.cursor = 'pointer';
      div.addEventListener('click', async () => {
        input.value = text;
        suggestionsContainer.innerHTML = '';
        const place_details =  await calToPlaceDetailsbyPlaceid(placeId);
        if(place_details){
          populateFields(place_details);
        }
      });
      suggestionsContainer.appendChild(div);
    });
  }
  if(input){
    input.addEventListener('focus', () => {
      suggestionsContainer.innerHTML = '';
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        suggestionsContainer.innerHTML = '';
      }
    });
    input.addEventListener('keydup', (event) => {
      if (event.key === 'Tab') {
        suggestionsContainer.innerHTML = '';
      }
    });
  }
  async function calToPlaceDetailsbyPlaceid(place_id) {
    const payload = {
      place_id: place_id,
      show_address1_code: true,
      show_city_code: true
    };
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
    };
    try {
      //const response = await fetch(`https://shopifymultishipapp-ec3e3bef6fd5.herokuapp.com/get-postal-address-by-place-id`, requestOptions);
      const response = await fetch(`${SHOPIFY_APP_BASE_URL}/get-postal-address-by-place-id`, requestOptions);

      const result = await response.json();
      if (result?.status?.toLowerCase() === "ok") {
        global_place_id=place_id;
        return result.data.address || [];
      } else {
        console.warn("Failed to fetch address suggestions:", result.message || "Unknown error");
        return '';
      }
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      return {};
    }
  }
  function populateFields(selectedAddress) {
    if (selectedAddress && typeof selectedAddress === 'object') {
      if (countryField) countryField.value = selectedAddress.country || '';
      if (address1Field) address1Field.value = selectedAddress.address1 || '';
      if (cityField) cityField.value = selectedAddress.city || '';
      if (stateField) stateField.value = selectedAddress.province || '';
      if (pinField) pinField.value = selectedAddress.zip || '';
      setTimeout(() => {
         loadAllStateCountryWise(selectedAddress.province);  // Custom function for handling states
      }, 300);
      mandatoryFieldChecking();
    }
  }
  function mandatoryFieldChecking() {
    const fields = [
      'AddressFirstNameNew',
      'AddressLastNameNew',
      'AddressAddress1New',
      'AddressCityNew',
      'AddressCountryNew',
      'AddressZipNew'
    ];
    const allFilled = fields.every(id => document.getElementById(id)?.value.trim() !== '');
    const target = document.querySelector('#addAddressForShipping');
    if (!target) return;
    if (allFilled) {
      target.classList.remove('read-only');
    } else {
      target.classList.add('read-only');
    }
  }
  function  loadAllStateCountryWise(state){

    const elementId = "AddressProvinceNew";
    const countrySelect = document.getElementById("AddressCountryNew");
    const provinceSelect = document.getElementById("AddressProvinceNew");
    const provinceContainer = document.getElementById("AddressProvinceContainerNew");
    provinceSelect.innerHTML = "";

    const selectedOptioncuntry = countrySelect.options[countrySelect.selectedIndex];
    const provincesData = selectedOptioncuntry.getAttribute("data-provinces");
    if (provincesData) {

      const provinces = JSON.parse(provincesData);

      provinces.forEach(([provinceName, displayName]) => {
        const option = document.createElement("option");
        option.value = provinceName;
        option.textContent = displayName;
        provinceSelect.appendChild(option);
      });
      provinceContainer.style.display = "block";
      selectElement(elementId, state);

    } else {
      // Hide the province container if no provinces are available
      provinceContainer.style.display = "none";
      document.getElementById("AddressProvinceContainerNew").value="";
    }
  }
  function selectElement(id, valueToSelect) {
    
    if (valueToSelect.length <= 2) {
      valueToSelect = stateShortCodeToActualName(valueToSelect);
    }
    let element = document.getElementById(id);
    
    element.value = valueToSelect;
  }
  function countryShortCodeToActualName(countryCode) {
    let countryName = "";
    switch (countryCode) {
        case "UK":
            countryName = "United Kingdom";
            break;
        case "US":
        case "USA": // Combine cases with the same result
            countryName = "United States";
            break;
        case "AE":
        case "UAE":
            countryName = "United Arab Emirates";
            break;
        default:
            countryName = countryCode; // Default to the countryCode if no match
    }
    return countryName;

  }
  function stateShortCodeToActualName(stateCode) {
    const stateMap = {
        AL: "Alabama",
        AK: "Alaska",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DC: "District of Columbia",
        DE: "Delaware",
        FL: "Florida",
        GA: "Georgia",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming"
    };
    const upperCaseCode = stateCode.toUpperCase();
    return stateMap[upperCaseCode] || "Invalid state code";
  }
  async function get_postal_code_suggestions_gapi(addressLine,functioncall=""){
    const request = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({ addressLine }),
    };

    try {
        const response = await fetch(`${SHOPIFY_APP_BASE_URL}/get-postal-code-suggestions-gapi`,request);
        const result = await response.json();
        //console.log(result);
        if (result?.status?.toLowerCase() === "ok") {
            if(functioncall==""){
              pinField.value=result.data
            }
            address2Field.focus();
            return result.data;
        } else {
            console.warn("Failed to fetch address suggestions:", result.message || "Unknown error");
            return '';
        }
    } catch (error) {
        console.error("Error fetching address suggestions:", error);
        return '';
    }
  }
  function countryNameToCountryCode(countryName) {
    const countryNameToCodeMap = {
      "United States": "US",
      "India": "IN",
      "United Kingdom": "GB",
      "Canada": "CA",
      "France": "FR",
      "Germany": "DE",
      // Add more country mappings as needed
    };
    const code = countryNameToCodeMap[countryName];
    return code || "Unknown Country Code";
  }
  document.querySelectorAll('.my-class').forEach(element => {
    element.addEventListener('change', function(event) {
        //const validdata = addresslinevalidation();
        global_place_id='';
    });
  });

  async function addresslinevalidation() {
    const address1Field = document.getElementById('AddressAddress1New').value.trim();
    const cityName = document.getElementById('AddressCityNew').value.trim();
    const countryName = document.getElementById('AddressCountryNew').value.trim();
    const pinField = document.getElementById('AddressZipNew').value.trim();
    const stateName = document.getElementById('AddressProvinceNew').value.trim();
    const addressLine = `${address1Field}, ${cityName}, ${stateName}, ${countryName}`;
    let zip = "";
    try {
        zip = await get_postal_code_suggestions_gapi(addressLine);

        if (zip && !Array.isArray(zip)) {
            document.getElementById('AddressZipNew').value = zip;
            removeClassesFromElements(
              '#addAddressForShipping',
              ['read-only']
            );
        } else {
            document.getElementById('AddressZipNew').value ="";
        }
    } catch (error) {
        document.getElementById('AddressZipNew').value ="";
        console.error("Error fetching postal code suggestions:", error);
    }
  }

  async function isAddressExistsInAddresslist(address) {
    const normalize = (str) => (str || "").trim().toLowerCase();
    const match = address_list.find((item) => {
      return (
        normalize(item.first_name) === normalize(address.firstName) &&
        normalize(item.last_name) === normalize(address.lastName) &&
        normalize(item.company) === normalize(address.company) &&
        normalize(item.address1) === normalize(address.address1) &&
        normalize(item.address2) === normalize(address.address2) &&
        normalize(item.city) === normalize(address.city) &&
        normalize(item.zip) === normalize(address.zip) &&
        normalize(item.phone) === normalize(address.phone) &&
        normalize(item.country) === normalize(address.country) &&
        normalize(item.country_name) === normalize(address.country_name) &&
        normalize(item.province) === normalize(address.province) &&
        normalize(item.name) === normalize(address.name)
      );
    });
    const returnId = match ? match.id : null;
    if (returnId) {
      const customer_id = document.querySelector('#customer_id')?.value || '';
      address["customer_id"] = customer_id;
      address["first_name"] = address.firstName;
      address["last_name"] = address.lastName;
      address["province_code"] = getStateCodeFromStateName(address.province);
      address["country_code"] =getCountryCodeFromCountryName(address.country);
      address["id"] =returnId;
      document.querySelector('#address_id').value = returnId;
      const detailsElement = document.querySelector(`#customer-address-details`);
      if (detailsElement) {
        detailsElement.innerHTML = JSON.stringify(address);
      }
    }
    return returnId;
  }

  function getStateCodeFromStateName(stateName) {
    const states = {
      "Alabama": "AL",
      "Alaska": "AK",
      "Arizona": "AZ",
      "Arkansas": "AR",
      "California": "CA",
      "Colorado": "CO",
      "Connecticut": "CT",
      "Delaware": "DE",
      "Florida": "FL",
      "Georgia": "GA",
      "Hawaii": "HI",
      "Idaho": "ID",
      "Illinois": "IL",
      "Indiana": "IN",
      "Iowa": "IA",
      "Kansas": "KS",
      "Kentucky": "KY",
      "Louisiana": "LA",
      "Maine": "ME",
      "Maryland": "MD",
      "Massachusetts": "MA",
      "Michigan": "MI",
      "Minnesota": "MN",
      "Mississippi": "MS",
      "Missouri": "MO",
      "Montana": "MT",
      "Nebraska": "NE",
      "Nevada": "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      "Ohio": "OH",
      "Oklahoma": "OK",
      "Oregon": "OR",
      "Pennsylvania": "PA",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      "Tennessee": "TN",
      "Texas": "TX",
      "Utah": "UT",
      "Vermont": "VT",
      "Virginia": "VA",
      "Washington": "WA",
      "West Virginia": "WV",
      "Wisconsin": "WI",
      "Wyoming": "WY"
    };
    return states[stateName.trim()] || "";
  }
  function getCountryCodeFromCountryName(countryName) {
    const countries = {
      "United States": "US",
      "Canada": "CA",
      "Mexico": "MX",
      // Add more as needed
    };
    return countries[countryName.trim()] || "";
  }

